export default __webpack_public_path__ + "static/media/jumber.33e800e8.png";